import type { PartnerResponse } from '../../repositories';

export class Partner {
  constructor(private apiResponse: PartnerResponse) {}

  public getCompanyName(): string {
    return this.apiResponse.company_name;
  }

  public getPartnerId(): number {
    return this.apiResponse.partner_id;
  }

  public getPartnerName(): string {
    return this.apiResponse.partner_name;
  }

  public getPartnerParentId(): number {
    return this.apiResponse.partner_parent_id;
  }

  public isSingleBill(): boolean {
    return this.apiResponse.features.single_bill;
  }

  public isUnmanagedCampaignCopy(): boolean {
    return this.apiResponse.features.unmanaged_campaign_copy;
  }

  public isPartnerAccountIdUi(): boolean {
    return this.apiResponse.features.partner_account_id_ui;
  }

  public isPartnerCancelUi(): boolean {
    return this.apiResponse.features.partner_cancel_ui;
  }

  public isPartnerProvisionAccountsToStripe(): boolean {
    return this.apiResponse.features?.provision_accts_to_stripe ?? false;
  }

  public getPartnerContactName(): string {
    return this.apiResponse.partner_contact_name;
  }

  public getPartnerContactEmail(): string {
    return this.apiResponse.partner_contact_email;
  }
}
